import { useReducer } from 'react';
import {
  activityCreationContentReducer,
  createInitialActivityCreationContent,
} from '../../activity-creation/activityCreationReducer';

export function useCreationContent() {
  const [state, dispatch] = useReducer(
    activityCreationContentReducer,
    undefined,
    createInitialActivityCreationContent,
  );
  const reset = () => dispatch({ type: 'form.reset' });
  const removeCard = () => dispatch({ type: 'card.removed' });
  return { state, dispatch, reset, removeCard };
}
